var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHost(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 24,
    viewBox: "0 0 24 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 24C17 22.6044 17 21.9067 16.8278 21.3389C16.44 20.0605 15.4395 19.06 14.1611 18.6722C13.5933 18.5 12.8956 18.5 11.5 18.5H6.5C5.10444 18.5 4.40665 18.5 3.83886 18.6722C2.56045 19.06 1.56004 20.0605 1.17224 21.3389C1 21.9067 1 22.6044 1 24M13.5 10.5C13.5 12.9853 11.4853 15 9 15C6.51472 15 4.5 12.9853 4.5 10.5C4.5 8.01472 6.51472 6 9 6C11.4853 6 13.5 8.01472 13.5 10.5Z",
    stroke: "white",
    strokeWidth: 2.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 4C13.1046 4 14 4.89543 14 6",
    stroke: "white",
    strokeWidth: 2.2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 2C14.2091 2 16 3.79086 16 6",
    stroke: "white",
    strokeWidth: 2.2,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12 0C16.4183 0 20 3.58172 20 8",
    stroke: "white",
    strokeWidth: 2.2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHost);
export default __webpack_public_path__ + "static/media/host.2a3d7b7cd22ba959bd4244df8b64fa80.svg";
export { ForwardRef as ReactComponent };